import LeftSideBarNavElysium from "./LeftSideBarNavElysium";

const MenuLayoutElysium = ({ children }) => {
    return (
        <div>
            <LeftSideBarNavElysium />
            {children}
        </div>
    )
}

export default MenuLayoutElysium;